import { ReactNode } from "react";
import { v4 as uuidv4 } from "uuid";
import { create } from "zustand";

export type ModalOption = {
	useDragPosition?: boolean;
	overlayClose?: boolean;
};

type Modal = {
	id: string;
	children: ReactNode;
	option?: ModalOption;
};

type ModalState = {
	modals: Modal[];
};

type ModalActions = {
	openModal: (children: ReactNode, option?: ModalOption) => string;
	closeModal: (id: string) => void;
};

export const useModalStore = create<ModalState & ModalActions>((set) => ({
	modals: [],
	openModal: (children, option = { useDragPosition: false }) => {
		const id = uuidv4();
		set((state) => ({
			modals: [...state.modals, { id, children, option }]
		}));
		return id;
	},
	closeModal: (id) =>
		set((state) => ({
			modals: state.modals.filter((modal) => modal.id !== id)
		}))
}));
